import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=94193024&"
import script from "./TextSection.vue?vue&type=script&lang=js&"
export * from "./TextSection.vue?vue&type=script&lang=js&"
import style0 from "./TextSection.vue?vue&type=style&index=0&id=94193024&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports